module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ce132277cd371cc58054ea72cd0cd95b.png";